import { Stack, Text } from "@mantine/core";
import { getOutgoers, Handle, Position } from "reactflow";
import { nodeEventWidth } from "../flowSettings";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import NodeBranchCreator from "../components/NodeBranchCreator";
import { useMemo } from "react";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";

const StartNode = ({ data, id, xPos, yPos }) => {
  const lang = useLanguage((s) => s.language);
  const layout = useFlowStore((s) => s.layout);
  const nodes = useFlowStore((s) => s.nodes);
  const edges = useFlowStore((s) => s.edges);
  const linking = useFlowStore((s) => s.linking);

  const outgoers = useMemo(() => {
    let n = nodes.find((x) => x.id === id);
    if (n)
      return getOutgoers(n, nodes, edges).filter((x) => x.type !== "trail");
    return [];
  }, [id, nodes, edges]);

  return (
    <>
      <Handle
        type="source"
        position={layout === "horizontal" ? Position.Right : Position.Bottom}
        style={{ visibility: "hidden" }}
      />
      <Stack w={nodeEventWidth}>
        <Text fz={"lg"} ta={"center"}>
          🚀 {layout === "horizontal" ? "" : lang.campaign.nodes.starting_node}
        </Text>

        {outgoers.length > 0 && !linking && (
          <NodeBranchCreator
            source={id}
            sourceX={xPos}
            sourceY={yPos}
            shouldBeEvent={true}
            error={data?.error}
            isStart
          />
        )}
      </Stack>
    </>
  );
};

export default StartNode;
